module.exports = "/assets/data/6cf9c58fd9250790adbaafe339120f10-CT17.data.json";